export default {"src":"https://appsumo2next-cdn.appsumo.com/_next/static/media/default-card.21af7a88.svg","height":76,"width":120};